import React, { forwardRef, useImperativeHandle } from 'react';

import { FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';

import FormError from '@components/FormError';
import FormGroup from '@components/FormGroup';
import Input from '@components/Input';
import Label from '@components/Label';

import { errors } from '@utils';

const WebmotorsConfig: React.ForwardRefRenderFunction<
  FormStepRef,
  IntegrationConfigProps
> = ({ initialValues, requestIntegrationConfiguration }, ref) => {
  const formikInitialValues: FormValuesIntegrationConfig = {
    token: '',
    ...initialValues,
  };

  const formikValidationSchema = yup.object().shape({
    token: yup.string().required(errors.required),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: formikInitialValues,
    validationSchema: formikValidationSchema,
    onSubmit: (values) => requestIntegrationConfiguration.mutate(values),
  });

  useImperativeHandle(ref, () => ({
    submit: formik.handleSubmit,
  }));

  return (
    <FormikProvider value={formik}>
      <FormGroup>
        <Label htmlFor="token">Token</Label>
        <Input
          type="text"
          name="token"
          placeholder="Ex: 53DAA..."
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.token}
          invalidValue={!!formik.touched.token && !!formik.errors.token}
        />
        <FormError name="token" />
      </FormGroup>
    </FormikProvider>
  );
};

export default forwardRef(WebmotorsConfig);
